import React from 'react';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import PropTypes from 'prop-types';

const styles = {
  appBarLogo: {
    display: 'block',
    maxWidth: 115,
    maxHeight: 52,
    width: 'auto',
    height: 'auto',
  },
};

const ToolbarOrgLogo = ({ orgLogoUrl, classes, href = null }) => {
  const img = <img src={orgLogoUrl} className={classes.appBarLogo} alt="logo" />;

  return href ? <a href={href}>{img}</a> : img;
};

ToolbarOrgLogo.propTypes = {
  orgLogoUrl: PropTypes.string,
  classes: PropTypes.shape({
    appBarLogo: PropTypes.string,
  }),
  href: PropTypes.string,
};
export default withStyles(styles)(ToolbarOrgLogo);
